
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1760.508a9.111 9.111 0 003.672-.747 9.726 9.726 0 005.078-5.078 9.43 9.43 0 000-7.334 9.731 9.731 0 00-5.093-5.083 9.406 9.406 0 00-7.324 0 9.731 9.731 0 00-5.083 5.083 9.4 9.4 0 000 7.334 9.758 9.758 0 005.087 5.078 9.087 9.087 0 003.663.747zm-2.3-7.256a13.161 13.161 0 01-1.479-1.753 7.827 7.827 0 01-.967-1.816 3.818 3.818 0 01-.239-1.719 2.352 2.352 0 01.713-1.44l.059-.059a.229.229 0 01.07-.049 2.036 2.036 0 01.61-.342.923.923 0 01.552-.024.849.849 0 01.449.347l1.172 1.66a1.012 1.012 0 01.254.718 1.264 1.264 0 01-.381.64l-.371.391a.262.262 0 00-.073.215.5.5 0 00.054.186 5.618 5.618 0 00.469.635q.322.391.713.791a10.185 10.185 0 00.786.713 6.44 6.44 0 00.64.469.428.428 0 00.225.059.277.277 0 00.205-.078l.371-.371a1.243 1.243 0 01.63-.366 1.015 1.015 0 01.728.239q.381.264.669.469l.537.381q.249.176.474.342a.791.791 0 01.371.747 1.446 1.446 0 01-.361.8q-.039.049-.073.1a.736.736 0 01-.083.1 2.39 2.39 0 01-1.445.713 3.829 3.829 0 01-1.719-.239 7.7 7.7 0 01-1.821-.972 13.371 13.371 0 01-1.744-1.487z"}})])])
          )
        }
      }
    